export default {"src":"/_next/static/media/heart-filled.ddf0100e.svg","height":19,"width":21};